import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'vp-grouped-button',
  templateUrl: './grouped-button.component.html'
})
export class GroupedButtonComponent implements OnInit {

  @Input() width: any;
  @Input() icon = 'pi pi-ellipsis-v';
  @Input() iconPosition = 'left';
  @Input() alignment: string;
  @Input() label: string;
  @Input() readOnly: boolean;
  @Input() styleClass: string;
  @Input() append: string;

  constructor() {}

  ngOnInit() {
    //do nothing
  }

}
